import ApiService from '../../../shared/services/ApiService';

export default{

    getMemberTimesheets(uid, from, to, jobSiteId = '', deleted = false){
        return ApiService.get(`/time-entries/web/${uid}/member?from=${from}&to=${to}&job_site_id=${jobSiteId}&deleted=${deleted}`);
    },

    getTimesheets(from, to, department = '', jobSiteId = '', deleted = false){
        return ApiService.get(`/time-entries/web?from=${from}&to=${to}&department=${department}&job_site_id=${jobSiteId}&deleted=${deleted}`);
    },

    getTimesheetById(id){
        return ApiService.get(`/time-entries/${id}/detail`);
    },

    getMemberDailyTimesheets(uid, date, deleted = false){
        return ApiService.get(`/time-entries/web/${uid}/member-daily?date=${date}&deleted=${deleted}`);
    },

    getMemberTimesheetSessions(uid, date, deleted){
        return ApiService.get(`/web-member-timesheets/${uid}/${date}?deleted=${deleted}`);
    },

    getTimeEntryForEdit(id) {
        return ApiService.get(`/time-entries/${id}/edit`);
    },

    newTimeEntry(data){
        return ApiService.post('/time-entries/manual-entry', data)
    },

    newTimeOffEntry(data){
        return ApiService.post('/time-entries/time-off-entry', data)
    },

    editTimeEntry(data){
        return ApiService.put(`/time-entries/manual-entry/${data.id}`, data)
    },

    editTimeOffEntry(data){
        return ApiService.put(`/time-entries/time-off-entry/${data.id}`, data)
    },

    deleteEntry(id){
        return ApiService.delete(`/time-entries/${id}`)
    },
    updateNote(id, data){
        return ApiService.put(`/time-entries/${id}/note`, data)
    },
    getTimeEntryMap(id) {
        return ApiService.get(`/time-entries/${id}/map?platform=web`);
    },
    syncTimesheet(data) {
        return ApiService.post('/sync-timesheet', data);
    },
    addTimesheetNote(data) {
        return ApiService.post('/add-note', data);
    },
    syncTimesheetJobs(data) {
        return ApiService.post('/sync-jobs', data);
    },
    syncTimesheetBreaks(data) {
        return ApiService.post('/sync-breaks', data);
    }
}